import { ACTIONS } from '../actions';

const defaultState = { search: null, showFinished: false, showTest: false };

export const allFiltersReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ACTIONS.SET_SEARCH_TEXT:
            return {
                ...state,
                search: action.payload === '' ? null : action.payload,
            };
        case ACTIONS.SET_SHOW_FINISHED:
            return {
                ...state,
                showFinished: action.payload,
            };
        case ACTIONS.SET_SHOW_TEST:
            return {
                ...state,
                showTest: action.payload,
            };
        default:
            return state;
    }
};
